import { Breakpoints, ScreenSize } from '@rategravity/own-up-component-library';

export const breakpoints: Breakpoints = {
  [ScreenSize.xsmall]: 375,
  [ScreenSize.small]: 640,
  [ScreenSize.medium]: 1024,
  [ScreenSize.large]: Number.POSITIVE_INFINITY
};
